import { render, staticRenderFns } from "./HightLight.vue?vue&type=template&id=9b970b5e&scoped=true&"
import script from "./HightLight.vue?vue&type=script&lang=js&"
export * from "./HightLight.vue?vue&type=script&lang=js&"
import style0 from "./HightLight.vue?vue&type=style&index=0&id=9b970b5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b970b5e",
  null
  
)

export default component.exports